import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Home")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_m_input = _resolveComponent("m-input")!
  const _component_m_datetime = _resolveComponent("m-datetime")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_m_select = _resolveComponent("m-select")!
  const _component_m_toggle = _resolveComponent("m-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  (_ctx.route.path != '/register_wedding')
                    ? (_openBlock(), _createBlock(_component_ion_back_button, {
                        key: 0,
                        "default-href": "/tabs/home/settings",
                        text: _ctx.$t('Cancel')
                      }, null, 8, ["text"]))
                    : (_openBlock(), _createBlock(_component_ion_button, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.replace('/tabs')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.home
                          }, null, 8, ["icon"]),
                          _hoisted_1
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "primary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _withModifiers(_ctx.onSubmitForm, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.checkmark
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Save')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Wedding Info')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode("form", {
            action: "#",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onSubmitForm()), ["prevent"])),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.onSubmitForm()), ["enter"]))
          }, [
            _createVNode(_component_ion_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_m_input, {
                  label: _ctx.$t('Partner One First Name'),
                  name: "bride_firstname"
                }, null, 8, ["label"]),
                _createVNode(_component_m_input, {
                  label: _ctx.$t('Partner One Last Name'),
                  name: "bride_lastname"
                }, null, 8, ["label"]),
                _createVNode(_component_m_input, {
                  label: _ctx.$t('Partner Two First Name'),
                  name: "groom_firstname"
                }, null, 8, ["label"]),
                _createVNode(_component_m_input, {
                  label: _ctx.$t('Partner Two Last Name'),
                  name: "groom_lastname"
                }, null, 8, ["label"]),
                _createVNode(_component_m_datetime, {
                  label: _ctx.$t('Wedding Day'),
                  "display-format": "DD MMMM YYYY",
                  placeholder: _ctx.$t('Select Date'),
                  name: "wedding_day",
                  min: (new Date()).getFullYear() - 10,
                  max: (new Date()).getFullYear() + 10
                }, null, 8, ["label", "placeholder", "min", "max"]),
                _createVNode(_component_m_datetime, {
                  label: _ctx.$t('Wedding Time'),
                  "display-format": "h:mm A",
                  "picker-format": "h:mm A",
                  placeholder: _ctx.$t('Select Time'),
                  name: "wedding_time"
                }, null, 8, ["label", "placeholder"]),
                _createVNode(_component_m_select, {
                  label: _ctx.$t('Wedding Type'),
                  name: "type"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mealTypes, (mealType) => {
                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                        key: mealType.id,
                        value: mealType.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(mealType.title)), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_m_input, {
                  label: _ctx.$t('Budget'),
                  name: "budget",
                  type: "number"
                }, null, 8, ["label"]),
                _createVNode(_component_m_toggle, {
                  label: _ctx.$t('Receive email notifications when a planner makes changes'),
                  name: "notification"
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}